import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import TaxConfirmationCriteria from "./TaxConfirmationCriteria";

@NeoReport("TaxConfirmation", { hidden: true })
export default class TaxConfirmationReport extends Report<TaxConfirmationCriteria> {

    constructor() {
        super(TaxConfirmationCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
        </div>;
    }
}